import React from 'react'
import GetStarted from '../../../components/GetStarted'
import Charges from '../Charges'
import Meals from '../Meals'

const Summary = props => {
  return (
    <div className="cookunity__summary">
      <Charges />
      <GetStarted />
      <Meals />
    </div>
  )
}

export default Summary



// WEBPACK FOOTER //
// ./src/modules/Checkout/Summary/Summary.jsx